const axios = require('axios')
const encrypt = require('./../encrypt.js')

const state = {
  alerts: [],
  xtoken: null
}

const actions = {
  async xToken ({ commit }) {
    try {
      const x = await axios.get('https://api.ipdata.co/?api-key=e87baad48c68cc058824af8ae850fdbbbafe67628db6f3ddb64e6f0b')
      const object = {
        x: x.data
      }
      const encryptedData = encrypt(JSON.stringify(object))
      commit('setXtoken', encryptedData)
    } catch (error) {
      console.error(error);
    }
  },
  addAlert ({ commit, getters }, addAlert) {
    const alerts = getters.getAlerts

    alerts.push(addAlert)

    commit('setAlerts', alerts)
  },
  removeAlert ({ commit }) {
    const alerts = []

    commit('setAlerts', alerts)
  },
  clearAlert ({ commit }) {
    commit('setAlerts', [])
  }
}

const mutations = {
  setAlerts (state, alerts) { state.alerts = alerts },
  setXtoken (state, data) { state.xtoken = data }
}

const getters = {
  getAlerts (state) { return state.alerts },
  getXtoken (state) { return state.xtoken }
}

export default {
  state,
  actions,
  mutations,
  getters
}
